module.exports = __webpack_public_path__ + "img/search_color.f7d3bd40.svg";